import React, { useEffect, useState, useContext } from 'react';
import Header from '../Header/AppHeader';
import moment from 'moment';
import Axiosfetch from '../Common/Axiosfetch';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../QuotationRecords/QuotationStyle.css';
import baseURL from '../Common/Config';
import { ThemeContext } from '../Common/ThemeProvider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
import FailureAlert from '../Common/Failure';
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import DataExport from '../Common/Export';

const PORecords = () => {

    const { CurrentTheme } = useContext(ThemeContext);

    const [POData, setPOData] = useState([]);

    const Failure = (err) => {
        FailureAlert(err);
    };

    const PODataSuccess = (data) => {
        setPOData(data);
    };

    const FetchPO = () => {
        Axiosfetch(baseURL + "GetAllPurchaseOrder", "GET", null, PODataSuccess, Failure);
    };

    const exportToCSV = () => {

        if (POData.length > 0) {
            const csvData = [];

            POData.map((po, index) => {
                return csvData.push({
                    SI: (index + 1),
                    PurchaseOrder: "PO/" + (po.Customer ? po.Customer.Name : "") + "/#" +
                        po.ID + "/" + moment(po.CreatedDate).local().format("DDMMYYYY"),
                    Supplier: po.Customer.Name,
                    Quantity: po.TotalQuantity,
                    Amount: po.TotalAmount,
                    CreatedDate: po.CreatedDate,
                });

            });

            DataExport(csvData, "PORecords");
        }
        else {
            Alert.error("No Data To Export", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    useEffect(() => {
        FetchPO();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            <Header></Header>
            <div className="container-fluid InvoiceTheme shadow sidemenu-show">
                <div className="row">
                    <div className={`${parseInt(process.env.REACT_APP_EXPORT_REQUIRED) === 1 ? "col-md-11 col-sm-11" : "col-md-12 col-sm-12"}`}>
                        <h5 className="align-center" style={{ fontWeight: "500" }}>PO Records</h5>
                    </div>
                    {parseInt(process.env.REACT_APP_EXPORT_REQUIRED) === 1 && (<div className="col-md-1 align-left">
                        <span data-tip="Export Quotation" className={`cursor font-size-15rem addIconFocus ${CurrentTheme}Color`} onClick={exportToCSV}>
                            <FontAwesomeIcon icon={faFileExcel} />
                        </span>
                    </div>)}
                </div>
                <div className="row" style={{ padding: "15px" }}>
                    <div className="col-md-12 tableQuotationRecordsStyle" style={{ scrollbarColor: "#005582 transparent" }}>
                        <table className="table table-striped">
                            <thead className="StickyHeader">
                                <tr>
                                    <th style={{ width: "300px" }} className={`align-center InvoicetitleStyle ${CurrentTheme}`}>PO #</th>
                                    <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}>Supplier</th>
                                    <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}>Perfoma Invoice</th>
                                    <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}>Quantity</th>
                                    <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}>Amount</th>
                                    <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}>Create Date</th>
                                </tr>
                            </thead>
                            <tbody style={{ fontSize: "14px" }}>
                                {
                                    POData.length > 0 && POData.map(po => (
                                        <tr key={po.ID} className="textCenter">
                                            <td>PO/{po.Customer ? po.Customer.Name.split(' ')[0].trim() : ""}/#{po.ID}/{moment(po.CreatedDate).local().format("DDMMYYYY")}</td>
                                            <td className="tdtableProductStyleQuotationrecord">{po.Customer ? po.Customer.Name : ""}</td>
                                            <td>{po.InvoiceNumber}</td>
                                            <td>{po.TotalQuantity}</td>
                                            <td>{po.TotalAmount}</td>
                                            <td>{moment(po.CreatedDate).local().format("DD MMMM YYYY hh:mm:ss A")}</td>
                                        </tr>
                                    ))
                                }
                                {
                                    POData.length === 0 && (<tr className="textCenter">
                                        <td colSpan="8">
                                            There are No Purchase Orders.
                                        </td>
                                    </tr>)
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PORecords;